import { NavbarEng, SidebarEng } from "../components/Navigation"
import Header from "../components/Header"
import FooterEng from "../components/FooterEng"
import { useParams } from "react-router-dom"
import { Link } from "react-router-dom"
import { habitatsEng } from "../array/habitats"
import Regresar from "../components/Regresar"
import ex from "../styles/exhibicionEspecie.module.css"
import cx from "classnames"

export default function Especie() {
    const { habitat, especie }  = useParams();

    const habitatInfo = habitatsEng.find(el => el.id == habitat);
    const especieInfo = habitatInfo.especies.find(el => el.route == especie);

    const headerName = especieInfo.nombre_display ? especieInfo.nombre_display : especieInfo.nombre_comun;

    return (
        <>
            <NavbarEng espLink={ "/habitats/" + habitatInfo.carpeta + "/" + habitatInfo.header_class + "/" + especieInfo.carpet_route }/>
            <SidebarEng espLink={ "/habitats/" + habitatInfo.carpeta + "/" + habitatInfo.header_class + "/" + especieInfo.carpet_route }/>
            <Header routeName={ habitatInfo.carpeta + "/" + habitatInfo.header_class } titleClasses={ habitatInfo.carpeta } altName="Hábitat header image" headerTitle={ headerName }/>

            <div className={ ex.contenido + " section" }>
                <div className={ ex.content + " content" }>
                    {/* Nombres y estatus de conservación */}
                    <div className={ cx(ex.contenido_des, ex.des) }>
                        <div className={ cx(ex.contenido__t1, ex.cientifico) }>{ especieInfo.nombre_cientifico }</div>
                        <div className={ ex.contenido__t2 }>{ especieInfo.nombre_comun }</div>
                        <div className={ ex.contenido__t1 }>Conservation status </div>
                        <div className={ ex.contenido__t2 }>{ especieInfo.conservacion }.<br/>Categories and criteria of the IUCN Red List:</div>
                        <img src="/images/habitats/estatus.svg" alt="Estatus de conservación" className={ ex.contenido__estatus }/>
                    </div>
                    {/* Imágenes */}
                    <div className={ ex.contenido_images }>
                        <img src={ "/images/" + habitatInfo.carpeta + "/" + habitatInfo.header_class + "/" + especieInfo.carpet_route + "/a.png" } srcSet={ "/images/" + habitatInfo.carpeta + "/" + habitatInfo.header_class + "/" + especieInfo.carpet_route + "/a.webp" } alt={ especieInfo.nombre_comun } className={ ex.contenido_images__el }/>
                        <img src={ "/images/" + habitatInfo.carpeta + "/" + habitatInfo.header_class + "/" + especieInfo.carpet_route + "/b.png" } srcSet={ "/images/" + habitatInfo.carpeta + "/" + habitatInfo.header_class + "/" + especieInfo.carpet_route + "/b.webp" } alt={ especieInfo.nombre_comun } className={ ex.contenido_images__el }/>
                    </div>
                    {/* Datos curiosos y generalidades */}
                    <div className={ cx(ex.contenido_des, ex.des) }>
                        <div className={ ex.contenido__t1 }>Fun facts</div>
                        { especieInfo.datos != undefined &&
                            especieInfo.datos.map((dato, index) =>
                                <div key={ index } className={ ex.contenido__t2 }>{ dato }</div>
                            )
                        }
                        <div className={ ex.contenido__t1 }>General aspects</div>
                        { especieInfo.generalidades != undefined &&
                            especieInfo.generalidades.map((generalidad, index) =>
                                <div key={ index } className={ ex.contenido__t2 }>{ generalidad }</div>)
                        }
                    </div>
                </div>

                <Regresar link={ "/eng/habitats/" + habitatInfo.habitat + "/" + habitat } des={ habitatInfo.nombre.charAt(0).toUpperCase() + habitatInfo.nombre.replace("/", " ").slice(1).toLocaleLowerCase() }/>
            </div>

            <FooterEng/>
        </>
    )
}